module.exports = __webpack_public_path__ + "18f75af3c70d77e80e6e94dac88bb8fa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-28.png
// module id = 1575
// module chunks = 0